import * as authorAllFeedActions from './../action_creators/author_all_feed_action_creators';
import AuthorAllFeedModel from '../../models/author_all_feed';
import log from '../../services/logger_service';

export default function fetchAuthorAllFeed(params, store) {
  return function authorAllFeed(dispatch) {
    dispatch(authorAllFeedActions.authorAllFeedLoading());
    return AuthorAllFeedModel.fetch(params, store)
      .then(function handleAuthorAllFeedData(authorAllFeedData) {
        dispatch(
          authorAllFeedActions.authorAllFeedLoaded(
            authorAllFeedData.data,
            store
          )
        );
      })
      .catch(function handleAuthorAllFeedError(err) {
        dispatch(authorAllFeedActions.authorAllFeedLoadError(err, store));
        log.error(
          err,
          `Error in all author all feed actions, message: ${err.message}`
        );
      });
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/async_author_all_feed_actions.js